var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import "./Reminders.css";
import { useTranslation } from "react-i18next";
import { useGetRemindersQuery } from "@/store/api";
import layoutComponentsDictionary from "@/components/forms/components/layout/layoutComponentsDictionary";
import RemindersBlock from "./reminderBlock";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAdd } from "@fortawesome/pro-solid-svg-icons";
import { getCurrentUser } from "@/store/utils/selectors/userSelector";
import { useAppSelector } from "@/hooks/store";
/**
 * Reminders edit component
 *
 * @param param0
 */
export function RemindersEdit(_a) {
    var fieldName = _a.fieldName, fieldDef = _a.fieldDef, record = _a.record, onUpdate = _a.onUpdate, moduleName = _a.moduleName;
    var t = useTranslation(["Meetings", "Calls", "common"]).t;
    /*
    const { data: currentUserResponse } = useGetCurrentUserQuery(null);
    const [currentUser, setCurrentUser] = useState<any>(
      currentUserResponse?.data?.record && currentUserResponse?.data?.record
    );
  
    useEffect(() => {
      currentUserResponse?.data?.record &&
        setCurrentUser(currentUserResponse?.data?.record);
    }, [currentUserResponse]);
  */
    var currentUser = useAppSelector(getCurrentUser);
    var defaultInvitee = [
        {
            id: "",
            value: currentUser === null || currentUser === void 0 ? void 0 : currentUser.attributes.name,
            module: "Users",
            module_id: currentUser === null || currentUser === void 0 ? void 0 : currentUser.id,
        },
    ];
    var defaultReminders = {
        id: "",
        popup: 1,
        email: 1,
        timer_popup: "1800",
        timer_email: "3600",
        invitees: defaultInvitee,
        isValid: true,
    };
    var recordId = record.id;
    var remindersResponse = useGetRemindersQuery({
        moduleName: moduleName,
        recordId: recordId,
    }).data;
    var saveReminder = (remindersResponse === null || remindersResponse === void 0 ? void 0 : remindersResponse.data) || [];
    var reminders = (saveReminder === null || saveReminder === void 0 ? void 0 : saveReminder.remindersData) || [];
    var app_strings = (saveReminder === null || saveReminder === void 0 ? void 0 : saveReminder.app_strings) || [];
    var _b = useState([]), remindersData = _b[0], setRemindersData = _b[1];
    var _c = useState([]), timeOptions = _c[0], setTimeOptions = _c[1];
    useEffect(function () {
        reminders && setRemindersData(reminders);
        record.id && onUpdate && onUpdate(__assign(__assign({}, record), { reminders: reminders }));
        saveReminder.reminder_time_options &&
            setTimeOptions(saveReminder.reminder_time_options);
    }, [remindersResponse]);
    var updateRemindersData = function (value) {
        setRemindersData(value);
        onUpdate && onUpdate({ reminders: value });
    };
    return (_jsx(_Fragment, { children: _jsx("div", __assign({ className: "function-edit" }, { children: _jsxs("div", __assign({ id: "reminders", className: "copie-reminders" }, { children: [_jsx("ul", __assign({ id: "reminder_view" }, { children: remindersData.map(function (reminder, index) { return (_jsx(RemindersBlock, { reminder: reminder, index: index, timeOptions: timeOptions, remindersInvitees: reminder.invitees, remindersData: remindersData, setRemindersData: updateRemindersData, defaultInvitee: defaultInvitee, appStrings: app_strings, module: moduleName, record: record })); }) })), _jsx("button", __assign({ className: "button success", onClick: function (e) {
                            currentUser &&
                                setRemindersData(__spreadArray(__spreadArray([], remindersData, true), [defaultReminders], false));
                            onUpdate &&
                                onUpdate({ reminders: __spreadArray(__spreadArray([], remindersData, true), [defaultReminders], false) });
                        } }, { children: _jsxs("span", { children: [_jsx(FontAwesomeIcon, { icon: faAdd, className: "pr-2 cursor-pointer text-white" }), t("LBL_REMINDERS_ADD_REMINDER")] }) }))] })) })) }));
}
layoutComponentsDictionary.registerLayoutComponent("reminders-edit", RemindersEdit);
